import { BaseService } from '../../base-service'

class ClinicalAuthApi {
    
    async validateClinicalUser(authoringSystem: string, authoringSystemForeignKey: string, userCreds: string) {
        const path = `/api/v1/oauth/validate-clinical-user`;
        let data = {
            authoringSystem: authoringSystem,
            authoringSystemForeignKey: authoringSystemForeignKey,
            userCreds: userCreds
        };
        return await BaseService.AsyncAnonymousPost(path, data);
    }
}

const clinicalAuthService = new ClinicalAuthApi();

export { clinicalAuthService };